<div class="mandala-wrap">
  <svg
    class="mandala-svg"
    [attr.viewBox]="'0 0 ' + viewBox + ' ' + viewBox"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet">

    <defs>
      <filter id="mandala-halo" x="-200%" y="-200%" width="500%" height="500%">
        <feGaussianBlur stdDeviation="3.5"/>
      </filter>
    </defs>

    <!-- Sparse star field — drifts in space around the floating mandala -->
    <g class="stars" opacity="0.75">
      <circle cx="24" cy="36" r="1" fill="#f5e6c8"/>
      <circle cx="210" cy="48" r="0.8" fill="#f5e6c8"/>
      <circle cx="36" cy="198" r="0.9" fill="#f5e6c8"/>
      <circle cx="218" cy="186" r="1" fill="#f5e6c8"/>
      <circle cx="176" cy="22" r="0.7" fill="#f5e6c8"/>
      <circle cx="20" cy="120" r="0.7" fill="#f5e6c8"/>
      <circle cx="222" cy="116" r="0.7" fill="#f5e6c8"/>
      <circle cx="110" cy="16" r="0.9" fill="#f5e6c8"/>
      <circle cx="116" cy="220" r="0.9" fill="#f5e6c8"/>
      <circle cx="64" cy="216" r="0.6" fill="#f5e6c8"/>
    </g>

    <g [attr.transform]="'translate(' + center + ' ' + center + ')'">
      <g *ngFor="let r of rendered; trackBy: trackByCategory"
         [class.pulsing]="isPulsing(r)"
         [class.dimmed]="isDimmed(r)"
         [class.leveling]="isLevelingUp(r)"
         [innerHTML]="r.ringSvg">
      </g>

      <!-- Decorative center "well" -->
      <circle cx="0" cy="0" r="14" fill="#1f4533" stroke="#bee9ca" stroke-width="1.2"/>
      <g>
        <ellipse cx="0" cy="-7" rx="2.2" ry="5.5" fill="#bee9ca"/>
        <ellipse cx="0" cy="-7" rx="2.2" ry="5.5" fill="#bee9ca" transform="rotate(72)"/>
        <ellipse cx="0" cy="-7" rx="2.2" ry="5.5" fill="#bee9ca" transform="rotate(144)"/>
        <ellipse cx="0" cy="-7" rx="2.2" ry="5.5" fill="#bee9ca" transform="rotate(216)"/>
        <ellipse cx="0" cy="-7" rx="2.2" ry="5.5" fill="#bee9ca" transform="rotate(288)"/>
        <circle cx="0" cy="0" r="2" fill="#fff3d6"/>
      </g>
    </g>
  </svg>

  <p *ngIf="rings.length === 0" class="mandala-empty">
    Add habits in categories to grow your mandala.
  </p>

  <div *ngIf="tierUpLabel" class="tier-up-label">{{ tierUpLabel }}</div>
</div>
